import axios from 'axios';
import qs from 'qs';
import { Toast } from 'antd-mobile';
import objconfig from './config'; //开发环境域名配置

// axios 配置
axios.defaults.timeout = 20000;
axios.defaults.baseURL = (process.env.NODE_ENV !== 'production' ? '' : objconfig.buildHttpUrl);
axios.defaults.withCredentials = true;
axios.defaults.responseType = 'json';
// http request 拦截器
axios.interceptors.request.use(config => {
        if (config.method === 'post') {
            //非文件上传类型
            if (config.type !== 'file') {
                config.data = qs.stringify(config.data);
            }
        } else if (config.method === 'get') {
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            config.params = config.data;
        }
        if (process.env.NODE_ENV !== 'production') {
            config.url = objconfig.devHttpUrl + config.url
        } else {
            config.url = config.url
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });

// http response 拦截器
axios.interceptors.response.use(response => {
        //未登录
        if ((response.data.code === -99 || response.data.code === '-99')) {
            Toast.offline('未登录')
        }
        return response;
    },
    error => {
        if (error.response) {
            Toast.offline('请求数据异常')
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    break;
                default:
                    break;
            }
        }
        return Promise.reject(error)
    });
export default axios;


// WEBPACK FOOTER //
// ./src/api/fetch.js